export const USAGE_SOURCE_OPTIONS = [
  { value: '', label: 'Все источники' },
  { value: 'miniapp', label: 'Mini App' },
  { value: 'playground_chat', label: 'Playground чат' },
  { value: 'playground_image', label: 'Playground изображения' },
  { value: 'playground_video', label: 'Playground видео' },
  { value: 'agent_test', label: 'Тест агента' },
  { value: 'agent_channel', label: 'Канал агента' },
  { value: 'telegram_business', label: 'Telegram Business' },
  { value: 'telegram_business_media', label: 'Telegram Business медиа' },
  { value: 'telegram_bot', label: 'Telegram Bot' },
  { value: 'telegram_business_backfill', label: 'Telegram Business досписание' },
] as const;

export function usageSourceLabel(source: string | null | undefined): string {
  if (!source) return 'н/д';
  const match = USAGE_SOURCE_OPTIONS.find((item) => item.value === source);
  if (match) return match.label;
  return source;
}
